const formatDuration = totalSeconds => {
  if (totalSeconds < 86400) {
    const result = new Date(Math.ceil(totalSeconds) * 1000)
      .toISOString()
      .substr(11, 8);
    return result.replace(/^0(?:0:0?)?/, '');
  }

  return totalSeconds;
};

export default formatDuration;
